import React, { useState, useEffect } from "react";

const OcenaStanko = () => {
	const [grade, setGrade] = useState();
	const [source, setSource] = useState("");
	const selectSource = (newSource) => {
		if (newSource === 1) {
			setGrade(1);
		} else if (newSource === 2) {
			setGrade(2);
		} else if (newSource === 3) {
			setGrade(3);
		} else {
			setGrade(9);
		}
	};

	useEffect(() => {
		if (grade === 1) {
			setSource(
				"https://docs.google.com/document/d/e/2PACX-1vQ-M7qx7A7V-zMZIarAruG7fv_W8RnnIwFpJ2BNmshS6WFLCGC3j0K9o8lL8TEUXcn3fluY9_4XceDH/pub"
			);
		} else if (grade === 2) {
			setSource(
				"https://docs.google.com/document/d/e/2PACX-1vR1bVNtjK0BuE0p92OEygBDtFupHL-1-glF3b7spklUQbJ-hNjiIC_TI_Nc34WDwjmBM2FCQkQFgSWj/pub"
			);
		} else if (grade === 3) {
			setSource(
				"https://docs.google.com/document/d/e/2PACX-1vS7cnE8uuiEwX-pGgd-wZyvbCt3wl0iIST7AD2VKf_HXYDYSIY8QtNhMpXFaP72rLmdO3t7g5gK4FVJ/pub"
			);
		} else if (grade === 9) {
			setSource(
				"https://docs.google.com/document/d/e/2PACX-1vRuLFXe1IodQXYN_t6esMJr8TeU-QxAB-e9s43_vJLDBVpUnQjrkLB5ULPLT0JBKdT16FoY4qv8qryf/pub"
			);
		} else {
			setSource("");
		}
	}, [grade]);
	return (
		<div className='ocena-container'>
			<h1>OCENJEVANJE - STANKO</h1>
			<h2>Izberi razred</h2>
			<div className='ocena-razred' onClick={() => selectSource(1)}>
				1. razred
			</div>
			<div className='ocena-razred' onClick={() => selectSource(2)}>
				2. razred
			</div>
			<div className='ocena-razred' onClick={() => selectSource(3)}>
				3. razred
			</div>
			<div className='ocena-razred' onClick={() => selectSource(9)}>
				8. in 9. razred
			</div>

			<div className='work-google'>
				{source === "" ? (
					<h2>Razred še ni izbran.</h2>
				) : (
					<iframe
						src={source}
						frameborder='0'
						width='1920'
						height='560'
						allowfullscreen='true'
						mozallowfullscreen='true'
						webkitallowfullscreen='true'
					></iframe>
				)}
			</div>
		</div>
	);
};

export default OcenaStanko;
